
import React from 'react';
import { useDrop } from 'react-dnd';

interface DropZoneProps {
  onDrop: (draggedId: string) => void;
  children: React.ReactNode;
  className?: string;
}

export const DropZone: React.FC<DropZoneProps> = ({ onDrop, children, className = '' }) => {
  const [{ isOver, canDrop }, drop] = useDrop(() => ({
    accept: 'RECORD',
    drop: (item: { id: string }) => {
      onDrop(item.id);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }));

  return (
    <div
      ref={drop}
      className={`relative transition-all duration-200 ${
        isOver && canDrop 
          ? 'ring-2 ring-green-400 bg-green-50 dark:bg-green-900/20 rounded-lg' 
          : ''
      } ${className}`}
    >
      {children}
      {isOver && canDrop && (
        <div className="absolute inset-0 flex items-center justify-center bg-green-100 dark:bg-green-900/40 rounded-lg border-2 border-dashed border-green-400">
          <span className="text-sm font-medium text-green-700 dark:text-green-300">
            Drop to link as child
          </span>
        </div>
      )}
    </div>
  );
};
